import styles from "@/common/SizeDropdown/SizeDropdown.module.scss";
import Dropdown from "@/common/Dropdown";
import MobileSizeComp from "../MobileSizeComp";
import { useSelector } from "react-redux";
import { getCookie } from "cookies-next";
import { useState, useEffect } from "react";
import { sortSizes, getQuantityAvailable } from "@/helpers/pdpHelpers";
import { generalConstants } from "@/utils/constants";
import SizeGuidePopUp from "../SizeGuidePopUp";
import { KlaviyoUserClickEvent } from "@/components/common/Klaviyo";

export default function SizeDropdown({
  sizeVariants,
  selectedSize,
  setSelectedSize,
  stickyProductBox,
  isStickyDropdownOpen,
  showStickyDropdown,
  isSizeDropdownOpen,
  setIsSizeDropdownOpen,
  AddToBag,
  sizeGuideType,
  productId,
  showLastOne,
  soldOutOptions,
  productDetails
}) {
  const [isOneSize, setOneSize] = useState(false);
  let sizeData = [];
  let disabled = [];
  let fastShippingVariants = [];
  let dropdownTitle = selectedSize ? "Selected size" : "Select your size";
  let innerDropUpTitle = "Select your size";
  const [singleOneSize, setSingleOneSize] = useState(false); // state for one size - 1 variant left
  let singleQuantity = [];

  for (const size in sizeVariants) {
    if (sizeVariants.hasOwnProperty(size)) {
      if(parseInt(sizeVariants[size].priceV2.amount)!=0)
      {
        sizeData.push(size);
      }
      if (!sizeVariants[size].availableForSale) disabled.push(size);
      if (sizeVariants[size].quantityAvailable === generalConstants.min_variant_quantity) {
        singleQuantity.push(size);
      }
      // variant is fast shipping when value of local item is "Local or MTO in stock"
      if (sizeVariants[size].local_item) {
        if(sizeVariants[size].local_item.value === "Local" || sizeVariants[size].local_item.value === "MTO in stock"){
        fastShippingVariants.push(size);
        }
      }
    }
  }
  // const isOneSize = sizeData.length === 1;
  sortSizes(sizeData);
  const handleDropdownToggle = (e) => {
    setIsSizeDropdownOpen(e);
    if (e) {
      if (productDetails?.named_tags?.category?.replace(/\s+/g, '')?.toLowerCase()?.includes("jewelry&watches"))
        KlaviyoUserClickEvent(productDetails, 'klaviyo_user_clicked_size_dropdown');
    }
  };

  
  const [loading, setLoading] = useState(false);

  const isWishlistLoading = useSelector(
    (state) => state.wishlist.loading_status
  );

  useEffect(() => {
    if (typeof sizeData[0] != "undefined" && sizeData[0].replace(/\s+/g, '').toLowerCase().includes(generalConstants.one_size_trimmed)) {
      setOneSize(true);
    } else {
      setOneSize(false);
    }
    if (getQuantityAvailable(sizeVariants) === 1) {
      setSingleOneSize(true);
    }
  });

  useEffect(() => {
    if (isWishlistLoading) {
      if (getCookie("isFavourite")) {
        setLoading(true);
      }
    } else {
      setLoading(false);
    }
  }, [isWishlistLoading]);

  return (
    <>
      {isOneSize && (
        <div
          className={`typography-wrap ${
            typeof showStickyDropdown != "undefined" && !showStickyDropdown
              ? "d-none"
              : ""
          }`}
        >
          <div className={`custom-dropdown`}>
              <div className={`dropdown-lable ${styles.disabled} onesize`}>One Size
              {sizeGuideType == 'Necklaces' && <SizeGuidePopUp sizeGuideType={sizeGuideType} className="xx-small sizeguide-span" />}
              {singleOneSize  && showLastOne && <span>1 left</span>}
              </div>         
          </div>
        </div>
      )}
      {!isOneSize && (
      
          <Dropdown
            ArrowDown="images/Icons/Chevron/large.svg"
            data={sizeData}
            disabled={disabled}
            selected={selectedSize}
            setSelected={setSelectedSize}
            isStickyDropdownOpen={isStickyDropdownOpen}
            showStickyDropdown={showStickyDropdown}
            isDropdownOpen={isSizeDropdownOpen}
            parentHandleToggle={handleDropdownToggle}
            selectedSize={selectedSize}
            isDropup={true}
            AddToBag={AddToBag}
            sizeGuideType={sizeGuideType}
            dropdownTitle={dropdownTitle}
            loading={loading}
            mobileSizeComp={<MobileSizeComp AddToBag={AddToBag} sizeGuideType={sizeGuideType}/>}
            innerDropUpTitle={innerDropUpTitle}
            sizeVariants={sizeVariants}
            productId={productId}
            singleQuantity={showLastOne?singleQuantity:""}
            fastShippingVariants={fastShippingVariants}
            soldOutOptions={soldOutOptions}
          />
      
      )}

      {stickyProductBox || (
        <div className={`d-none d-md-block ${styles.size_guide}`}>
          <span className={`xx-small `}>
            <a>Size Guide</a>
          </span>
        </div>
      )}
    </>
  );
}
